import React from "react";
import { FormattedMessage, injectIntl } from 'react-intl';
import cx from "classnames";
import withStyles from "isomorphic-style-loader/withStyles";
import { Container } from "react-bootstrap";
import Loader from '../../components/Common/Loader/Loader';
import Link from '../../components/Link/Link';
import NotFound from "../not-found/NotFound";

import PriceDetails from "../../components/BookingDetail/PriceDetails/PriceDetails"
import OrderDetails from "../../components/BookingDetail/OrderDetails/OrderDetails";
import ConfirmBookingBanner from "../../components/ConfirmBookingBanner/ConfirmBookingBanner"
import ViewBookingSkeleton from "../../components/Skeleton/ViewBooking/ViewBookingSkeleton/ViewBookingSkeleton";
import history from "../../history";

import messages from "../../locale/messages";
import { encode } from "../../helpers/queryEncryption";
import useQueryResponse from "../../lib/hooks/useQueryResponse";
import getOrder from "./getOrder.graphql";
import { AngleLeftArrowIcon } from "../../components/Common/Assets/SVGIcon/CommonSvgIcon";
import bt from '../../components/commonStyle.css';
import s from './ViewBooking.css'


const ViewBooking = () => {
    const { data, loading } = useQueryResponse({
        query: getOrder,
        variables: {
            promoId: null
        },
        ssr: false,
        fetchPolicy: 'network-only'
    })

    let initialValues = {
        validPromoCode: data?.getOrder?.result?.promoId,
        promoId: data?.getOrder?.result?.promoId,
    }

    let categoryId = data?.getOrder?.result?.categoryDetails?.id || ''
    if (!loading && data?.getOrder?.result == null) {
        history.push('/bookings/upcoming')
    } else if (loading) {
        return <div className={'subPageContainer'}>
            <Container>
                <ViewBookingSkeleton />
            </Container>
        </div>
    }
    else {
        return (
            <div className={'subPageContainer'}>
                <Container>
                    <>
                        <div className={cx(bt.space3, s.topLinkContainer)}>
                            <Link to={`/category?type=${encodeURIComponent(encode(categoryId?.toString()))}`} className={cx(bt.customLink, 'customLinkRtl')} >
                                <AngleLeftArrowIcon />
                                <FormattedMessage {...messages.goBackText} />
                            </Link>
                        </div>
                        <div className={bt.commonViewBookingContainer}>
                            <div className={bt.commonViewBookingLsBox}>
                                <OrderDetails loading={loading} data={data?.getOrder} reviewPage={true} isOrderPage={true} />
                            </div>

                            <div className={bt.commonStickyRsContainer}>
                                <PriceDetails loading={loading} data={data?.getOrder} isOrderPage={true} promoCodeValues={initialValues} />
                            </div>
                        </div>

                    </>
                    <ConfirmBookingBanner loading={loading} data={data?.getOrder} />
                </Container>
            </div>
        )
    }
}
export default injectIntl(withStyles(bt, s)(ViewBooking))